
import Vue from '../../plugins/vue'
import Ad from './components/Ad'
import store from '../shared/store'

const queue = [];

async function prepareAds() {
	const items = {};

	for(const { config } of queue) {
		const { position, transformation } = config;
		const key = `ad-${position}-${transformation}`;
		if(!items[key]) {
			items[key] = { position, transformation, key }
		}
	}

    // Preload all ads instead of doing a fetch in each ad
	await store.dispatch('fetchMultipleAds', items);

	for(const { config, element } of queue) {

		new Vue({
			name: 'NettnoAd',
			store: store,
			render: h => h(Ad, {
				props: config
			})
		}).$mount(element);
	}
}

const contentBlocks = document.querySelectorAll('article .content-block');

// We need to inject the ad somewhere in the content for smaller devices.
// Or the ad is placed way at the bottom.
function createtopAsideRightArticlePlacement(element) {
    let parent = contentBlocks.item(contentBlocks.length - 1);
    let combiedHeight = 0;
    let lastParent = null;
    for(const x of contentBlocks) {
        combiedHeight += x.offsetHeight;
        if(combiedHeight > 400) {
            parent = lastParent ?? x;
            break;
        }
        lastParent = x;
    }

    if(parent) {
        const clone = element.cloneNode(true);
        const p = parent.querySelectorAll('p');
        let moved = false;
        if(p.length > 0) {
            if(p[0].offsetHeight > 200 || p.length == 1) {
                p[0].after(clone);
                moved = true;
            } else {
                p[1].after(clone);
                moved = true;
            }
        }

        if(!moved) {
            parent.before(clone);
        }

        return clone;
    }

    contentBlocks.forEach(x => {
        if(combiedHeight > 400) {

        }
    });

    return null;
}

document.querySelectorAll('.nettno-ads').forEach(element => {
	const config = JSON.parse(element.dataset.config ?? null);

	if(config?.transformation) {

        if(config?.position == 'topAsideRightArticle') {
            const clone = createtopAsideRightArticlePlacement(element);
            if(clone) {
                queue.push({
                    config: {...config, ...{ classList: (config.classList ?? '') +  ' xl:hidden my-8'}},
                    element: clone
                });
                config.classList = (config.classList ?? '') + ' hidden xl:block';
            }
        }

        queue.push({
			config,
			element
		});

	} else {
		console.warn('No transformation specified for element:', element);
	}
});

prepareAds();
